'use client'

import { useRef, useMemo, useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

const RouteLoaderProvider = () => {
	// Variables
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const searchParamsString = useMemo(() => searchParams.toString(), [searchParams])
	const previousPath = useRef<string>(pathname)
	const previousSearchParams = useRef<string>(searchParamsString)

	// Callbacks
	useEffect(() => {
		if (previousPath.current !== pathname || previousSearchParams.current !== searchParamsString) {
			NProgress.start()
			previousPath.current = pathname
			previousSearchParams.current = searchParamsString

			const timeout = setTimeout(() => {
				NProgress.done()
			}, 50)

			return () => clearTimeout(timeout)
		}
	}, [pathname, searchParamsString])

	return null
}

export default RouteLoaderProvider
